jQuery(function ($) {

  $('[data-modal-open]').on('click', function () {
    const id = $(this).data('modal-open');
    $('#' + id).addClass('is-active');
    $('body').addClass('is-modal-open');
  });

  $('[data-modal-close]').on('click', function () {
    $(this).closest('.modal-overlay').removeClass('is-active');
    $('body').removeClass('is-modal-open');
  });

  $('.modal-overlay').on('click', function (e) {
    if (e.target === this) {
      $(this).removeClass('is-active');
      $('body').removeClass('is-modal-open');
    }
  });

  $(document).on('keydown', function (e) {
    if (e.key === 'Escape') {
      $('.modal-overlay.is-active').removeClass('is-active');
      $('body').removeClass('is-modal-open');
    }
  });

});
